import { CabinetManagerRoleType } from '../manager';

export type AccessRecoveryCabinet = {
  cabinetId: string;
  name: string;
  role: CabinetManagerRoleType;
};

export enum AccessRecoverySessionStorageKey {
  token = 'access_recovery_token',
  cabinets = 'access_recovery_cabinets',
  flowKind = 'access_recovery_flow_kind'
}

export enum AccessRecoveryFlowKind {
  FAST_TRACK = 'fast_track',
  LINK = 'link'
}

export enum AccessRecoveryCompletedQueryParam {
  accessRecoveryCompleted = 'accessRecoveryCompleted'
}

export const ACCESS_RECOVERY_COMPLETED_SUCCESS_VALUE = '1';

const readSessionStorage = (
  key: AccessRecoverySessionStorageKey
): string | null => {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeSessionStorage = (
  key: AccessRecoverySessionStorageKey,
  value: string
): void => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Failed to write session storage key ${key}`);
  }
};

const removeSessionStorage = (key: AccessRecoverySessionStorageKey): void => {
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Failed to remove session storage key ${key}`);
  }
};

export const saveAccessRecoveryToken = (token: string): void => {
  writeSessionStorage(AccessRecoverySessionStorageKey.token, token);
};

export const getAccessRecoveryToken = (): string | null =>
  readSessionStorage(AccessRecoverySessionStorageKey.token);

export const saveAccessRecoveryFlowKind = (
  flowKind: AccessRecoveryFlowKind
): void => {
  writeSessionStorage(AccessRecoverySessionStorageKey.flowKind, flowKind);
};

export const getAccessRecoveryFlowKind = (): AccessRecoveryFlowKind | null => {
  const raw = readSessionStorage(AccessRecoverySessionStorageKey.flowKind);

  return Object.values(AccessRecoveryFlowKind).includes(
    raw as AccessRecoveryFlowKind
  )
    ? (raw as AccessRecoveryFlowKind)
    : null;
};

export const saveAccessRecoveryFastTrackSession = (token: string): void => {
  saveAccessRecoveryToken(token);
  saveAccessRecoveryFlowKind(AccessRecoveryFlowKind.FAST_TRACK);
};

export const clearAccessRecoverySession = (): void => {
  removeSessionStorage(AccessRecoverySessionStorageKey.token);
  removeSessionStorage(AccessRecoverySessionStorageKey.flowKind);
};
